export enum FillableDocumentStatus {
    NEW = 'NEW',
    BEING_FILLED_OUT = 'BEING_FILLED_OUT',
    PENDING_SIGNATURE = 'PENDING_SIGNATURE',
    SIGNED = 'SIGNED',
    VOIDED = 'VOIDED'
}
